import React, { Component } from 'react'

import Loading from '../Shared/Loading'
import EmptyState from '../Shared/EmptyState'
import ListItem from './ListItem'

export default class AddonsList extends Component {
  renderContent() {
    const { list } = this.props

    if (!list) {
      return (
        <EmptyState greedy>
          <Loading large />
        </EmptyState>
      )
    }

    if (list.length === 0) {
      return <EmptyState>No Addons Available</EmptyState>
    }

    return list.map(itm => <ListItem key={itm.id} item={itm} />)
  }

  render() {
    const { title } = this.props

    return (
      <div className="addons-list-wrapper">
        <h2>{title}</h2>
        <div className="addons-list">{this.renderContent()}</div>
      </div>
    )
  }
}
